import { render, staticRenderFns } from "./WiseEmbedHost.vue?vue&type=template&id=6587420f&scoped=true&"
import script from "./WiseEmbedHost.vue?vue&type=script&lang=js&"
export * from "./WiseEmbedHost.vue?vue&type=script&lang=js&"
import style0 from "./WiseEmbedHost.vue?vue&type=style&index=0&id=6587420f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587420f",
  null
  
)

export default component.exports